import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Farm Name",
  "Crop",
  "Harvest Quantity",
  "packaging Type",
  "selling Price (kg)",
  "total harvest price",
  "Actions",
];

const tableHeadClient = [
  "Sr.",
  "Crop",
  "Harvest Quantity",
  "packaging Type",
  "selling Price (kg)",
  "total harvest price",
  "Actions",
];

function Harvestmanagementtable({ data = [], currentPage, itemsPerPage }) {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const goToView = (id) => {
    navigate(`/farm-harvest-management/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {store.Role === process.env.REACT_APP_ROLE_CLIENT
              ? tableHeadClient?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })
              : tableHead?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td>{item?.farmName || "N/A"}</td>
                )}
                <td>{item?.selectCrop || "N/A"}</td>
                <td>{item?.harvestQuantity || "N/A"}</td>
                <td>{item?.packagingType || "N/A"}</td>
                <td>₹{item?.sellingPricePerKg || "N/A"}</td>
                <td>₹{item?.totalHarvestPrice || "N/A"}</td>
                <td>
                  <CustomViewButton onClick={() => goToView(item?.id)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Harvestmanagementtable;
